import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconDownload = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={28}
      height={28}
      fill="none"
      viewBox="0 0 28 28"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3C14.5523 3 15 3.44772 15 4V13.9267L17.6795 10.7448C18.0353 10.3223 18.6661 10.2682 19.0886 10.624C19.511 10.9797 19.5651 11.6106 19.2094 12.033L14.7649 17.3108C14.5749 17.5364 14.295 17.6667 14 17.6667C13.705 17.6667 13.4251 17.5364 13.2351 17.3108L8.79064 12.033C8.4349 11.6106 8.48897 10.9797 8.91142 10.624C9.33387 10.2682 9.96472 10.3223 10.3205 10.7448L13 13.9267V4C13 3.44772 13.4477 3 14 3ZM6 15.6667C6.55228 15.6667 7 16.1144 7 16.6667V20.8889C7 21.2338 7.11688 21.5372 7.28561 21.7375C7.45001 21.9328 7.63239 22 7.77778 22H20.2222C20.3676 22 20.55 21.9328 20.7144 21.7375C20.8831 21.5372 21 21.2338 21 20.8889V16.6667C21 16.1144 21.4477 15.6667 22 15.6667C22.5523 15.6667 23 16.1144 23 16.6667V20.8889C23 21.6638 22.7423 22.4343 22.2442 23.0258C21.7418 23.6224 21.0198 24 20.2222 24H7.77778C6.98017 24 6.25818 23.6224 5.75579 23.0258C5.25772 22.4343 5 21.6638 5 20.8889V16.6667C5 16.1144 5.44772 15.6667 6 15.6667Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
